import throttle from 'lodash/throttle';

const referenceNode = document.createElement('div');

const supportsOuterHTML = !!referenceNode.outerHTML;
const supportsClassList = !!(referenceNode.classList && !!referenceNode.classList.add);

export function outerHTML(node) {
  if (supportsOuterHTML) {
    return node.outerHTML;
  }

  var container = document.createElement('div');
  container.appendChild(node.cloneNode(true));
  return container.innerHTML;
}

export function removeNode(node) {
  if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

export function addClass(node, name) {
  if (supportsClassList) {
    return node.classList.add(name);
  }

  // ensure class is not in classList first
  removeClass(node, name);
  node.className = `${node.className} ${name}`;
}

export function removeClass(node, name) {
  if (supportsClassList) {
    return node.classList.remove(name);
  }

  const regex = new RegExp(`\\b${name}\\b`, 'g');
  node.className = node.className.replace(regex, '');
}

export function hasClass(node, name) {
  if (supportsClassList) {
    return node.classList.contains(name);
  }

  return node.className.indexOf(name) !== -1;
}

export function toggleClass(node, name) {
  if (hasClass(node, name)) {
    removeClass(node, name);
  } else {
    addClass(node, name);
  }
}

function getCustomEventObject(eventName, params) {
  if (typeof window.CustomEvent === 'function') {
    return new CustomEvent(eventName, params);
  }

  const evt = document.createEvent('CustomEvent');
  evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
  return evt;
}

export function createEvent(eventName, params = {}, data = {}) {
  const defaultParams = {
    bubbles: false,
    cancelable: false,
    detail: undefined,
  };

  const normalizedParams = {
    ...defaultParams,
    ...params,
  };

  const evt = getCustomEventObject(eventName, normalizedParams);
  // merge data params into event object
  return Object.keys(data).reduce((result, key) => {
    result[key] = data[key];
    return result;
  }, evt);
}

// NOTE: taken from https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
export function matches(el, selector) {
  if (el.matches) {
    return el.matches(selector);
  }

  const matches = (el.document || el.ownerDocument).querySelectorAll(selector);
  let i = matches.length;
  while (--i >= 0 && matches.item(i) !== el) {}
  return i > -1;
}

export function closest(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  if (!el || !el.parentElement) return null;
  else if (matches(el.parentElement, selector)) return el.parentElement;
  else return closest(el.parentElement, selector);
}

export function monitorInputValueChanges(input) {
  function onContentChange(event) {
    if (input.value !== input.oldValue) {
      input.oldValue = input.value;
      input.dispatchEvent(createEvent('value:changed'));
    }
  }

  const throttledOnContendChange = throttle(onContentChange, 250);
  input.addEventListener('change', throttledOnContendChange);
  input.addEventListener('keyup', throttledOnContendChange);
}
